import React from 'react';

const PrivacyPolicyContent = () => {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4 text-base-content leading-relaxed space-y-6">
      <div className="border-b border-base-200 pb-4 mb-6">
        <h1 className="text-3xl font-extrabold text-base-content mb-2">
          Privacy Policy
        </h1>
        <p className="text-sm font-semibold text-base-content/70">
          Effective Date: August 4, 2026
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">1. Information We Collect</h2>
        <p>
          When you interact with Insurance Enterprise USA ("Company," "we," "us," or "our") through our website, online quote forms, enrollment tools, email, telephone, text messaging, or other communications, we may collect information you voluntarily provide, including:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Name and contact information.</li>
          <li>Mailing address.</li>
          <li>Date of birth.</li>
          <li>Insurance-related information.</li>
          <li>Demographic information.</li>
          <li>Information necessary to evaluate eligibility, obtain insurance quotes, process applications, enroll coverage, administer policies, or respond to your requests.</li>
          <li>Any other information you choose to provide during the application or enrollment process.</li>
        </ul>
        <p>
          Where applicable, this information may include personal information or protected information necessary for insurance underwriting and servicing.
        </p>
        <p>
          We may also use browser local storage and cookies to remember site preferences and maintain operational functionality.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">2. How We Use Your Information</h2>
        <p>We may use the information we collect to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Provide insurance quotes.</li>
          <li>Evaluate eligibility for insurance products.</li>
          <li>Process applications and enrollments.</li>
          <li>Verify identity.</li>
          <li>Communicate regarding quotes, applications, policies, renewals, billing, or customer service.</li>
          <li>Meet contractual, regulatory, legal, and compliance obligations.</li>
          <li>Improve our website, products, and services.</li>
          <li>Detect fraud, unauthorized activity, or security incidents.</li>
          <li>Maintain business records and operational functions.</li>
        </ul>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">3. Sharing of Information</h2>
        <p>We may disclose information, as permitted or required by applicable law, to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Licensed insurance carriers.</li>
          <li>General agencies.</li>
          <li>Third-party administrators.</li>
          <li>Technology and service providers performing services on our behalf.</li>
          <li>Regulatory agencies.</li>
          <li>Government authorities when legally required.</li>
          <li>Professional advisors, auditors, or legal counsel.</li>
          <li>Successors in connection with a merger, acquisition, or sale of business assets.</li>
        </ul>
        <p>
          We do not sell your personal information to third parties for their independent marketing purposes unless permitted by law or authorized by you.
        </p>
        <p>
          Any third-party service providers receiving information on our behalf are expected to protect such information through appropriate contractual or legal obligations.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">4. Privacy Compliance</h2>
        <p>
          Insurance Enterprise USA is committed to protecting your information in accordance with applicable federal and state privacy laws.
        </p>
        <p>
          Where applicable, we comply with the Health Insurance Portability and Accountability Act (HIPAA), the Gramm-Leach-Bliley Act (GLBA), and other applicable privacy and insurance regulations governing the information we collect and maintain.
        </p>
        <p>
          Nothing in this Privacy Policy expands or limits any rights or obligations established under applicable law.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">5. Information Security</h2>
        <p>
          We maintain administrative, technical, and physical safeguards designed to protect personal information against unauthorized access, disclosure, alteration, or destruction.
        </p>
        <p>
          Although we employ commercially reasonable security measures, no method of electronic transmission or storage can be guaranteed to be completely secure. Accordingly, we cannot guarantee absolute security.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">6. Data Retention</h2>
        <p>We retain personal information only for as long as reasonably necessary to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Provide requested services;</li>
          <li>Comply with legal and regulatory obligations;</li>
          <li>Resolve disputes;</li>
          <li>Enforce agreements; and</li>
          <li>Maintain appropriate business records.</li>
        </ul>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">7. Your Privacy Rights</h2>
        <p>Subject to applicable federal and state law, you may request to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Access certain personal information we maintain;</li>
          <li>Correct inaccurate information;</li>
          <li>Update your contact preferences;</li>
          <li>Request deletion where legally permitted; or</li>
          <li>Inquire about our privacy practices.</li>
        </ul>
        <p>
          Certain information may be retained where required by law or for legitimate business purposes.
        </p>
      </div>

      <div className="space-y-4">
        <h2 className="text-xl font-bold text-base-content">8. Changes to This Privacy Policy</h2>
        <p>
          We may revise this Privacy Policy from time to time. Any changes become effective upon posting the updated version with a revised Effective Date unless otherwise required by law.
        </p>
      </div>

      <div className="space-y-4 border-t border-base-200 pt-6">
        <h2 className="text-xl font-bold text-base-content">9. Contact Information</h2>
        <p className="font-semibold">Insurance Enterprise USA</p>
        <p>Phone: 888-350-6605</p>
        <p>Email: enroll@insuranceenterpriseusa.com</p>
        <p>Website: insuranceenterpriseusa.com</p>
      </div>
    </div>
  );
};

export default PrivacyPolicyContent;
